import { SelectableLink, SelectableLinkContainer } from "components/Link";
import { TextStyle } from "components/Text";
import Title from "components/Title";
import { doorCloses } from "core/constants/sound";
import { roles } from "core/constants";
import { getRandomItem } from "core/utils/logic";
import { processText } from "core/utils/string";
import { useEscapeGoesBack } from "hooks/navigation";
import React from "react";
import styled from "styled-components";
import { desktop } from "submodules/sharedText/flavor";
import { usePlaySoundEffect } from "hooks/sound";
import Character from "components/CharacterWeb";
const { GARLIC_FARMER, PRIEST, LIBRARIAN, MAYOR, CULLEN, VAMPIRE, HUMAN } =
  roles;

const { general, credit } = desktop;
const flavor = { ...general, ...credit };

const Wrapper = styled.div`
  // display: grid;
  text-align: center;
  margin: 3vw;
`;
const CharactersWrapper = styled.div`
  display: flex;
  width: 70%;
  margin: 5vw auto;
  align-items: center;
  justify-content: space-around;
`;

const Text = styled(TextStyle)`
  margin-top: 1vw;
  font-size: 3vw;
`;

const SubTitle = styled(TextStyle)`
  margin-top: 1vw;
  font-size: 5vw;
  margin: 5vw 0;
`;

const Rules = () => {
  const playSoundEffect = usePlaySoundEffect();
  const escapeGoesBack = useEscapeGoesBack();

  return (
    <Wrapper>
      <SubTitle white>Rules</SubTitle>
      <SelectableLinkContainer handleKeyDown={escapeGoesBack}>
        <SelectableLink
          to="/desktop"
          onClick={() => playSoundEffect(getRandomItem(doorCloses))}
          backButton
        />
      </SelectableLinkContainer>
      <Text white>Vampire party is a game of survival and secrecy.</Text>
      <Text white>
        he minority of the players are vampires pitted against the majority,
        humans.
      </Text>
      <Text white>
        Humans win if all vampires are exterminated. Vampires win if there are
        more vampires than humans.
      </Text>
      <Text white>
        On your phone you will see which character role you have been assigned.
        Don't share this info with other players. Your character is a secret you
        should take to the grave.
      </Text>
      <Text white>
        Every aspect of the game involves voting or making choices about other
        players. Use your real names. If you don't use real names, it'll be
        confusing, harder to learn, and subsequently less fun.
      </Text>
      <SubTitle white>Night and Day</SubTitle>
      <Text white>
        During the Night characters perform their unique abilities.
      </Text>
      <Text white>
        During the Day players vote to kill a Player who they think is a
        vampire.
      </Text>
      <CharactersWrapper>
        <Character role={VAMPIRE} scale={1.5} />
        <Character role={VAMPIRE + 2} scale={1.5} />
        <Character role={VAMPIRE + 3} scale={1.5} />
      </CharactersWrapper>
      <Text white>
        The vampires get to choose one player to attack. But their success is by
        no means guaranteed. (See Garlic Farmer and Cullen) Majority wins, but
        if there is a tie, nobody dies.
      </Text>
      <CharactersWrapper>
        <Character role={GARLIC_FARMER} scale={1.5} s />
      </CharactersWrapper>
      <Text white>
        The Garlic farmers can give out one garlic a night and have enough
        garlic to give out one to every player.
      </Text>
      <Text white>
        If a human player receives garlic they will be protected from the
        vampires for the night.
      </Text>
      <Text white>
        If a Vampire is given garlic the hunt is off and everyone is safe for
        the night.
      </Text>
      <Text white>
        If given garlic there is a chance the Cullen will die or turn into a
        full fledged vampire.
      </Text>
      <Text white>
        The Cullen - the reclusive vegetarian vampire - wins and loses with the
        humans.
      </Text>
      <CharactersWrapper>
        <Character role={CULLEN} scale={1.5} s />
      </CharactersWrapper>
      <Text white>
        If the Cullen is attacked by Vampires the Vampires will be stunned and
        will lose their action the following night. If given garlic there is a
        chance the Cullen will die or turn into a full fledged vampire.
      </Text>
      <CharactersWrapper>
        <Character role={LIBRARIAN} scale={1.5} s />
        <Character role={LIBRARIAN + 2} scale={1.5} s />
      </CharactersWrapper>
      <Text white>
        The Librarian may research a player to try and learn if they are vampire
        or human. This is an art not a science and the Librarian is not always
        correct.
      </Text>
      <CharactersWrapper>
        <Character role={MAYOR} scale={1.5} s />
        <Character role={MAYOR + 2} scale={1.5} s />
      </CharactersWrapper>
      <Text white>
        The Mayor is presented with an option to use their Mayoral powers. If
        used, the Mayoral super vote will beat all other none politicians. It
        can only be used once.
      </Text>
      <CharactersWrapper>
        <Character role={PRIEST} scale={1.5} s />
        <Character role={PRIEST + 2} scale={1.5} s />
      </CharactersWrapper>
      <Text white>
        Once a game the Priest will have a chance to resurrect a human player
        that died.
      </Text>
    </Wrapper>
  );
};

export default Rules;
